import { withKeycloak } from "@react-keycloak/web";
import { withRouter } from "react-router-dom";
import { labels } from "../../../../../localization/labels";
import ClassificationService from "../../../../../services/ClassificationService";
import OccurrencesContainer from "../Occurrences";

class TopClassificationsContainer extends OccurrencesContainer {
  constructor(props) {
    super(props);
    this.classificationService = new ClassificationService(this.keycloak);
  }

  loadOccurrences = () => {
    const pageInfo = { size: 5 };
    this.prepareCall(
      this.classificationService.getClassificationOccurrence(
        pageInfo,
        this.onOccurrencesLoaded,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  occurrenceMapper = element => ({
    classificationName: element.name,
    classifications: element.occurrence,
    id: element.id
  });

  xDataKey = () => "classifications";

  yDataKey = () => "classificationName";

  getComponentTitle = () => {
    return labels.mostPopularClassifications;
  };
}
export default withKeycloak(withRouter(TopClassificationsContainer));
